import { Field } from 'formik';
import type { FormikHandlers } from 'formik';

import { FormControl, FormLabel, Input } from '@frontend/legacy-components';

type AwsCredentialsInputProps = {
  onChange: FormikHandlers['handleChange'];
};

const AwsCredentialsInput = ({ onChange }: AwsCredentialsInputProps) => {
  return (
    <>
      <FormControl>
        <FormLabel>AWS Customer Access Key</FormLabel>
        <Field as={Input} name="awsCustomerAccessKey" onChange={onChange} />
      </FormControl>
      <FormControl>
        <FormLabel>AWS Customer Secret Key</FormLabel>
        <Field as={Input} name="awsCustomerSecretKey" onChange={onChange} />
      </FormControl>
    </>
  );
};

export default AwsCredentialsInput;
